import React from "react";

function Testimonial({ slider }) {
  const { media_url, name, description, review } = slider;
  return (
    <div className="testimonial-item text-center mx-auto">
      <div className="thumb mb-3 mx-auto">
        {media_url ? <img src={media_url} alt="customer-name" /> : ""}
      </div>
      <h4 className="mt-3 mb-0">{name}</h4>
      <span className="subtitle">{description}</span>
      <div className="bg-white padding-30 shadow-dark rounded triangle-top position-relative mt-4">
        <p className="mb-0">{review}</p>
      </div>
    </div>
  );
}

export default Testimonial;
